module.exports = __webpack_public_path__ + "media/images/common/sns/youtube-0afb3696c02f56983994e7d56b2376f2.svg";